import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=53f88a5d&"
import script from "./CopyModal.vue?vue&type=script&lang=js&"
export * from "./CopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f88a5d')) {
      api.createRecord('53f88a5d', component.options)
    } else {
      api.reload('53f88a5d', component.options)
    }
    module.hot.accept("./CopyModal.vue?vue&type=template&id=53f88a5d&", function () {
      api.rerender('53f88a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CopyModal.vue"
export default component.exports